// hooks/useProfile.js
import { useState, useEffect } from 'react';
import { profileService } from '../services/profileService';
import useWallet from './useWallet';
import { defaultUserProfile } from '../utils/constant';

export const useProfile = (logedIn, handleWalletDisconnectWithReset ) => {
    const { address, isConnected, connect, connectors, disconnect } = useWallet();
    
    const [userProfile, setUserProfile] = useState({
        name: 'User',
        imageUrl: '\\assets\\useer.svg',
        description: '',
        email: '',
        twitter: '',
        instagram: '',
        discord: ''
    });
    const [isLoadingProfile, setIsLoadingProfile] = useState(false);

    const fetchUserProfile = async () => {
        try {
            setIsLoadingProfile(true);
            const profileData = await profileService.fetchProfile();

            if (profileData) {
                setUserProfile({
                    name: profileData?.name || defaultUserProfile?.name ,
                    imageUrl: profileData?.imageUrl || defaultUserProfile?.imageUrl,
                    description: profileData?.description || '',
                    email: profileData?.email || '',
                    twitter: profileData?.socialLinks?.twitter || '',
                    instagram: profileData?.socialLinks?.instagram || '',
                    discord: profileData?.socialLinks?.discord || ''

                    
                });
            }
        } catch (error) {
            console.error('Failed to fetch profile:', error);
            // ✅ Handle expired JWT
            if (error?.statusCode === 401 || error?.message === 'jwt expired') {
                handleWalletDisconnectWithReset();
            }
        } finally {
            setIsLoadingProfile(false);
        }
    };

    const updateProfile = async (profileData, profileImage) => {
        try {
            const updatedProfile = await profileService.updateProfile(profileData, profileImage);
// console.log(updatedProfile, 'updatedProfile');

            if (updatedProfile) {
                setUserProfile({
                    name: updatedProfile.name || 'User',
                    imageUrl: updatedProfile.imageUrl || '\\assets\\useer.svg',
                    description: updatedProfile.description || '',
                    email: updatedProfile.email || '',
                    twitter: updatedProfile.socialLinks.twitter || '',
                    instagram: updatedProfile.socialLinks.instagram || '',
                    discord: updatedProfile.socialLinks.discord || ''
                });
            }

            return updatedProfile;
        } catch (error) {
            throw error;
        }
    };

    const resetProfile = () => {
        setUserProfile({
            name: 'User',
            imageUrl: '\\assets\\useer.svg',
            description: '',
            email: '',
            twitter: '',
            instagram: '',
            discord: ''
        });
    };
    // Fetch profile when connected
    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        if (token && isConnected && logedIn) {
            fetchUserProfile();
        }
    }, [isConnected, logedIn]);
    return {
        userProfile,
        isLoadingProfile,
        fetchUserProfile,
        updateProfile,
        resetProfile
    };
};